exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shortcuts-row[data-v-54b3bf5c]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.shortcuts-inner[data-v-54b3bf5c]{background:#fff;padding:10px 15px;border:1px solid #ddd}.shortcuts-inner a[data-v-54b3bf5c]{text-decoration:none}.shortcuts-inner a[data-v-54b3bf5c]:hover{text-decoration:underline}.shortcuts-bar-space-above[data-v-54b3bf5c]{margin-top:15px}", ""]);

// exports
